import { createContext } from 'react'
import type { ModerationErrorKind } from '../../lib/moderationError'
import type { Notification, NotificationStatus } from '../types'

/** Известный отказ модерации, который карточка объясняет сама. */
export type ModerationIssue = Exclude<ModerationErrorKind, 'other'>

export interface NotificationsUiContextValue {
  open: boolean
  setOpen: (open: boolean) => void
  notifications: Notification[]
  setNotifications: (notifications: Notification[]) => void
  addNotification: (notification: Notification) => void
  removeNotification: (id: number) => void
  /** Отметить заявку одобренной/отклонённой: карточка получает статус, считается прочитанной
   *  (уходит из новых во вкладку «Прочитанное») и сохраняет исход между снимками WS. */
  resolveNotification: (id: number, status: NotificationStatus) => void
  /** Новое ли уведомление (прочитанность — локальная, в localStorage по пользователю). */
  isNew: (notification: Notification) => boolean
  /** Только новые, в порядке списка: бейдж, «Все», вкладки категорий и панели считают их. */
  newNotifications: Notification[]
  moderationIssues: Record<number, ModerationIssue>
  /** Запомнить, почему заявку нельзя одобрить/отклонить; пока открыто окно — карточка это показывает. */
  setModerationIssue: (id: number, issue: ModerationIssue) => void
}

export const NotificationsUiContext = createContext<NotificationsUiContextValue | null>(null)
